import * as CubeTree from '../../cubeTree/index';
import * as Toolkit from '../../toolkit/index';
import { __walk__, __length__, __clearShortLink__, __getLinks__ } from './db';
import { cubeModify } from '../../update/cubeModify';
import { updateLayoutKey, getGroupList, updateGroupedKey } from './link';
import { groupLayout } from './groupLayout';

let updateGroupStyleTimer: number;

function renderLinkStyle(links: LinkedListInstance[]): void {
    let linkLen: number = __length__();

    links.forEach((link: LinkedListInstance, index: number): void => {
        if (link.length === 1) {
            let layerId: CubeId = link.getElementAt(0).val;
            let layer: CubeNode = CubeTree.findByCubeId(layerId);
            let $left: JQuery<HTMLElement> = layer.jView.find('.group-left');
            let $right: JQuery<HTMLElement> = layer.jView.find('.group-right');

            $right.hasClass('group-right--show')
                && $right.removeClass('group-right--show');
            $left.hasClass('group-left--show')
                && $left.removeClass('group-left--show');
            return;
        }

        link.walk((layerId: CubeId, index: number): void => {
            let layer: CubeNode = CubeTree.findByCubeId(layerId);
            let $left: JQuery<HTMLElement> = layer.jView.find('.group-left');
            let $right: JQuery<HTMLElement> = layer.jView.find('.group-right');

            if (index === 0) {
                $left.hasClass('group-left--show')
                    && $left.removeClass('group-left--show');
                !$right.hasClass('group-right--show')
                    && $right.addClass('group-right--show');
                return;
            }

            if (index === link.length - 1) {
                $right.hasClass('group-right--show')
                    && $right.removeClass('group-right--show');
                !$left.hasClass('group-left--show')
                    && $left.addClass('group-left--show');
                return;
            }

            !$right.hasClass('group-right--show')
                && $right.addClass('group-right--show');
            !$left.hasClass('group-left--show')
                && $left.addClass('group-left--show');
        });
    });
}

export {
    renderLinkStyle
};
